import React, {Component} from "react";
import {createRoot} from "react-dom/client";
import "../../sass/_document.scss";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import Player from "../components/Player/Player";
import Grid from "../components/Grid/Grid";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import Title from "../components/Title/Title";
import Common from "../utils/common";
import AmbassadorHelper from "../utils/AmbassadorHelper";
import store from "../store/store";
import * as actionType from "../store/actions";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import theme from "../../sass/variables.json";

const {asset} = ConfigurationHelper.getGlobalConfiguration().channelVideosData;

class Video extends Component {
    state = {
        breadcrumbsList: [],
        channelApiUrl:null,
        gridTitle:(asset && (asset.matched && asset.matched.length))?"RELATED CONTENT" : "LATEST CONTENT"
    }
    api = `${ConfigurationHelper.getGlobalConfiguration().apiUrl}channels/${ConfigurationHelper.getRelatedVideosChannelId()}/contents`
    componentDidMount() {
        store.subscribe(this.updateAmbassador)
    }

    updateAmbassador = () => {
        const storeState = store.getState();
        if (storeState.event === actionType.UPDATE_BREADCRUMBS) {
            const breadCrumbs = [];
            let hasData = false;
            if (storeState && storeState.ambassador && ConfigurationHelper.isAmbassadorProgramEnabled()) {
                breadCrumbs.push({
                    name: AmbassadorHelper.getDisplayNameFromApi(storeState.ambassador),
                    url: ConfigurationHelper.getGlobalConfiguration().public_base_url+ConfigurationHelper.getGlobalConfiguration().sub_folder + "/a/" + storeState.ambassador.user_slug + "/" + storeState.ambassador.user_id,
                    highlightMobile: true
                });
                hasData = true;
            } else if (!ConfigurationHelper.isAmbassadorProgramEnabled()) {
                const entityType = storeState.asset.entityType === 7 ? "Photo" : "Video";
                breadCrumbs.push({
                    name: entityType,
                    highlightMobile: false,
                    hideItemOnMobile: true,
                    keepOnMobile: false
                });
            }
            if (storeState && storeState.asset) {
                breadCrumbs.push({
                    name: storeState.asset.title,
                    url: Common.getVideoPageUrl(storeState.asset),
                    active: true,
                    hideItemOnMobile: ConfigurationHelper.isAmbassadorProgramEnabled()
                });
            }
            this.setState({
                breadcrumbsList: breadCrumbs,
                channelApiUrl:this.getApiUrl(asset,hasData)
            });
        }
    }
    getApiUrl = (asset, isAmbassador) => {
		if(!asset) return null;

		let url;
		if (isAmbassador) {
            url = `${this.api}?user_id=${asset.owner.id}`;
        }
		else if (asset && (asset.matched && asset.matched.length)){
			url = `${this.api}?s=${escape(asset.matched[0].title)}`;
		}
		else {
			url = `${ConfigurationHelper.getGlobalConfiguration().apiUrl}channels/${ConfigurationHelper.getLatestVideosChannelId()}/contents`;
		}

		return url;
    }

    render() {
        const {breadcrumbsList, channelApiUrl,gridTitle} = this.state;
        return (
            <div className={"document-body "+theme.hub_wrapper_css_class}>
                {ConfigurationHelper.enableHeaderFooter() && <Header/>}
                <Breadcrumbs keepOnMobile breadcrumbsList={breadcrumbsList}/>
                {(asset && asset.id) && <Player enableDetails={true} asset={asset}/>}
                <div className={"container"}>
                    <div className={"row"}>
                        <Title className={"col-12"}>{(gridTitle && gridTitle.length) ?gridTitle:null}</Title>
                    </div>
                </div>
                { (channelApiUrl && channelApiUrl.length) ?<Grid gridTitle={null} currentAsset={asset.id} baseApiUrl={channelApiUrl}/>:null}
                {ConfigurationHelper.enableHeaderFooter() && <Footer/>}
            </div>
        );
    }

}

const targetEl = document.getElementById("app-container");
if(targetEl){
    const root = createRoot(targetEl)
    root.render(<Video/>);
}